import script from "./SettingsOEMContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsOEMContent.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsOEMContent.vue?vue&type=style&index=0&id=2ff87e9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff87e9e"]])

export default __exports__